module.exports = __webpack_public_path__ + "static/img/evidence3.05f4332.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/evidence3.png
// module id = 4MUP
// module chunks = 1 3